import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ws_common_operation ws_pt10 ws_pb24" }

import { ref, onMounted, computed } from 'vue'
  import ChipForm from './chip-form.vue'
  import {
    queryChipPage,
    deviceChipDelete,
  } from '@/api'
  import { CODE_ENUM, PAGE_SIZES } from '@/common'
  import moment from 'moment'
  import OperationButtonList from '@/components/operation-button-list'
  import { msgbox, downLoadFile } from '@/utils'
  import { ElMessage } from 'element-plus'
  

  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'chip-table',
  setup(__props) {

  const buttonList = [
    {
      type: 'edit',
      text: '编辑',
    },
    {
      type: 'delete',
      text: '删除',
    },
  ]
  
  const col: any = ref([
    {
      prop: 'chipType',
      label: '芯片类型',
    },
    {
      prop: 'producer',
      label: '厂商',
    },
    {
      prop: 'createDate',
      label: '创建时间',
      width: '160',
      formatter: ({ createDate }: any) => {
        return createDate ? moment(createDate).format('YYYY-MM-DD') : '-'
      },
    },
  ])
  
  const tableData: any = ref([])
  const pageParams = ref({
    curPage: 1,
    pageSize: 10,
  })
  const total = ref(0)
  const handleSizeChange = (pageSize: number) => {
    pageParams.value.curPage = 1
    fetchList()
  }
  const handleCurrentChange = (pageSize: number) => {
    fetchList()
  }
  
  const tableLoading = ref(false)
  const fetchList = async (queryData?: any) => {
    tableLoading.value = true
  
    const res: any = await queryChipPage({
      ...pageParams.value,
    }).finally(() => {
      tableLoading.value = false
    })
    if (res?.code === CODE_ENUM.SUCCESS) {
      tableData.value = res?.data?.records || []
      total.value = res?.data?.total || 0
    }
  }
  
  onMounted(() => {
    fetchList()
  })
  
  const cardConf = ref({
    visible: false,
    data: {},
  })
  
  const handleForm = (data?: any) => {
    cardConf.value = {
      visible: true,
      data,
    }
  }
  
  const handleDelete = (data: any) => {
    msgbox({
      tip: '请确认是否删除这个芯片类型？',
      thenFn: () => toDelete(data),
    })
  }
  
  const toDelete = async ({ id }: any) => {
    const res: any = await deviceChipDelete({
      id,
    })
    if (res.code === CODE_ENUM.SUCCESS) {
      ElMessage.success(res?.msg)
      fetchList()
    }
  }
  
  
return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        onClick: handleForm,
        type: "primary",
        class: "ws_ml16"
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加")
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      class: "ws_common_table"
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, { description: "暂无数据" })
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: item.prop
          }, { ...item }, { "show-overflow-tooltip": "" }), null, 16))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(OperationButtonList), {
              scope: scope.row,
              buttonList: buttonList,
              onOnDelete: handleDelete,
              onOnEdit: handleForm
            }, null, 8, ["scope"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "ws_mt50",
      "current-page": pageParams.value.curPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
      "page-size": pageParams.value.pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
      "page-sizes": _unref(PAGE_SIZES),
      layout: "->, total, sizes, prev, pager, next, jumper ",
      total: total.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"]),
    _createVNode(ChipForm, {
      visible: cardConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((cardConf.value.visible) = $event)),
      data: cardConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})